goog.provide('el8.app.service.UILayout');

goog.require('el8.core.service.UILayout');
goog.require('el8.model.base');


/**
 * This object extends the el8.core.service.UILayout object, to add
 * a few additional methods that are helpful for the app pages.
 */
el8.app.service.UILayout = function() {};
el8.app.service.UILayout.inheritsFrom(el8.core.service.UILayout);

el8.app.service.UILayout.prototype.setup = function(spec) {
    spec = spec || {};
    this._innerContainerSelector = spec.innerContainerSelector || null;

    if (spec.headerInitFn) { spec.headerInitFn(); }
    if (spec.footerInitFn) { spec.footerInitFn(); }

    if (spec.notLegacy) {
      // We don't want any of the rest to run in our new React/ES6 pages. Not sure
      // what value manually updating page height/width in response to window resizing
      // provides.
      return;
    }

    this.onResize();
    this.setInnerContainerHeight();
    var that = this;

    el8.core.service.UILayout.prototype.setup.apply(this, arguments);

    this.addResizeListener(function() { that.setInnerContainerHeight(); });

    return this;
};

/**
 * This function is bound to the window resize event in el8.core.service.UILayout
 */
el8.app.service.UILayout.prototype.onResize = function() {

    var width = this.getAppWidth();
    var height = this.getAppHeight();

    // We want to set the width and height of the #page-{APP}
    // container every time the window resizes
    $('#page-'+el8Globals['APP']).outerWidth(width).outerHeight(height);

    el8.core.service.UILayout.prototype.onResize.apply(this, arguments);
};

el8.app.service.UILayout.prototype.setInnerContainerHeight = function() {
    if (this._innerContainerSelector) {
        $(this._innerContainerSelector).height(this.getAppInnerHeight());
    }
};

/**
 * Over-ride el8.core.service.UILayout's getAppHeight(), since on app pages we can
 * have additional banners in the $(window) that we don't want to think of
 * as contributing to the app's height
 */
el8.app.service.UILayout.prototype.getAppHeight = function() {
    return $(window).height() -
        (el8Globals['TEASE'] ? el8Globals['TOUR_VISOR_HEIGHT'] : 0);
};

/**
 * Get the app's width excluding the fourth pane:
 * Use getAppWidth if you want to base your calculation on the whole screen
 * and getAppInnerWidth if you want to avoid overlapping with the fourth pane
 */
el8.app.service.UILayout.prototype.getAppInnerWidth = function() {
    var $fourthPane = $('#fourth-pane');
    if ($fourthPane.length && $fourthPane.is(':visible')) {
        return $(window).width() - $fourthPane.width();
    }
    return $(window).width();
};

/**
 * Get the app's height excluding the header and the footer
 */
el8.app.service.UILayout.prototype.getAppInnerHeight = function() {
    return this.getAppHeight()
        - this.getAppHeaderHeight();
};

/**
 * Get the chart's height excluding the header and the footer AND the write/see bar
 */
el8.app.service.UILayout.prototype.getChartInnerHeight = function() {
    return this.getAppInnerHeight()
        - this._getDivHeight('#chart-write-see-bar');
};

/**
 * Get the app's header height, excluding banners & headlines
 */
el8.app.service.UILayout.prototype.getAppHeaderHeight = function() {
    return this._getDivHeight('#page-header')
        + this._getDivHeight('#page-banner')
        + this._getDivClassHeight('.app-headline');
};

/**
 * Helper method for computing heights
 */
el8.app.service.UILayout.prototype._getDivHeight = function(selector) {
    return ($(selector).length && $(selector).is(':visible')) ? $(selector).outerHeight(true) : 0;
};

el8.app.service.UILayout.prototype._getDivClassHeight = function (
    classSelector
) {
    var totalHeight = 0;
    $(classSelector).each(function () {
        var $this = $(this);
        if ($this.is(":visible")) {
            totalHeight += $this.outerHeight(true) || 0;
        }
    });
    return totalHeight;
};
